import { twMerge } from "tailwind-merge";

interface InfoCardProps {
  className?: string;
  children: React.ReactNode;
}

export function InfoCard({ className, children }: InfoCardProps) {
  return (
    <div className={twMerge("rounded-card border bg-white", className)}>
      {children}
    </div>
  );
}

interface InfoCardValueProps {
  className?: string;
  children: React.ReactNode;
}

export function InfoCardValue({ className, children }: InfoCardValueProps) {
  return (
    <span className={twMerge("text-[13px] font-semibold", className)}>
      {children}
    </span>
  );
}

interface InfoCardMutedProps {
  className?: string;
  children: React.ReactNode;
}

export function InfoCardMuted({ className, children }: InfoCardMutedProps) {
  return (
    <span
      className={twMerge(
        "text-content-muted text-[13px] font-medium",
        className,
      )}
    >
      {children}
    </span>
  );
}

interface InfoCardHeaderProps {
  title: string;
  right?: React.ReactNode;
}

export function InfoCardHeader({ title, right }: InfoCardHeaderProps) {
  return (
    <div className="border-brand-gray flex items-center justify-between border-b px-5 py-4">
      <span className="text-content-emphasis text-[13px] font-semibold">
        {title}
      </span>
      {right}
    </div>
  );
}
